import React from 'react'
import { connect } from 'react-redux'
import { Route } from 'react-router-dom'

// Routes
import MainCommon from './MainCommon'
import MainProtected from './MainProtected'
// Components
import Loader from '../components/Loader'

class MainRoutes extends React.Component {
    state = {}

    async componentDidMount() {}

    render() {
        const { app_loaded } = this.props

        return (
            // <Suspense fallback={<></>}>
            <>
                {/*Protected routes*/}
                {app_loaded ? (
                    <Route
                        path={[
                            '/account/settings',
                            '/account/billing-and-payments',
                            '/account/my-projects',
                            '/account/my-projects/:id/analytics',
                            '/account/editor',
                            '/editor',
                            // '/oauth2/successful-registration',
                        ]}
                        component={MainProtected}
                    />
                ) : null}
                {/*Public routes*/}
                <Route
                    path={[
                        '/',
                        '/template-gallery/:id?',
                        '/about',
                        '/contacts',
                        '/investors',
                        '/how-it-works',
                        '/products/:name',
                        '/404',
                    ]}
                    component={MainCommon}
                />

                {/*Loader*/}
                {!app_loaded ? <Loader text="App loading..." /> : null}
            </>
            // </Suspense>
        )
    }
}

const mapStateToProps = state => {
    return {
        app_loaded: state.app_loaded,
    }
}

export default connect(mapStateToProps, null)(MainRoutes)
